 (function ($) {
 
    $(function() {
        $(".desktop-banner").slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            adaptiveHeight: true,
            dots: true,
			arrows: true,
			rows:0,
            //prevArrow: '<button type="button" class="slick-prev"><span class="arrow previous"><svg class="arrows"  width="60" height="60" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96"><title/><path d="M39.3756,48.0022l30.47-25.39a6.0035,6.0035,0,0,0-7.6878-9.223L26.1563,43.3906a6.0092,6.0092,0,0,0,0,9.2231L62.1578,82.615a6.0035,6.0035,0,0,0,7.6878-9.2231Z"/></svg></span></button>',
            //nextArrow: '<button type="button" class="slick-next"><span class="arrow next"><svg class="arrows"  width="60" height="60" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96"><title/><path d="M69.8437,43.3876,33.8422,13.3863a6.0035,6.0035,0,0,0-7.6878,9.223l30.47,25.39-30.47,25.39a6.0035,6.0035,0,0,0,7.6878,9.2231L69.8437,52.6106a6.0091,6.0091,0,0,0,0-9.223Z"/></svg></span></button>'
            prevArrow: '<button type="button" class="slick-prev"><span class="arrow previous"><svg class="arrow" width="38" height="75" viewBox="0 0 100 100" style="fill: rgb(255, 255, 255);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow"></path></svg></span></button>',
            nextArrow: '<button type="button" class="slick-next"><span class="arrow next"><svg class="arrow" width="38" height="75" viewBox="0 0 100 100" style="fill: rgb(75, 76, 76);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></span></button>'
        });


        $(".mobile-banner").slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            adaptiveHeight: true,
            dots: true,
			arrows: true,
			rows:0,
            prevArrow: '<button type="button" class="slick-prev"><span class="arrow previous"><svg class="arrow" width="19" height="43" viewBox="0 0 100 100" style="fill: rgb(255, 255, 255);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow"></path></svg></span></button>',
            nextArrow: '<button type="button" class="slick-next"><span class="arrow next"><svg class="arrow" width="19" height="43" viewBox="0 0 100 100" style="fill: rgb(75, 76, 76);"><path d="M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></span></button>'
        });
        $(".hero-banner .content-block").css("display","block");
    });
    
})(jQuery);